import copy from "./copy";
import googleTranslate from "./googleTranslate";

export default [
  copy,
  googleTranslate,
] as const;
